<template>
  <div class="nft-card-back-mmbs">
    <mv-progress-bar
      v-show="info.total"
      :data="{
        start: 0,
        end: info.total,
        current: info.current,
      }"
    />
    <div class="text-area">
      <div class="main-text">{{ data.name }}</div>
      <div class="sub-text">
        <span v-if="data.attributes?.startDate">{{ info.startDate }} ~</span>
        <span v-if="data.attributes?.endDate">&nbsp;{{ info.endDate }}</span>
      </div>
      <div class="sub-text">
        <span v-if="data.attributes?.startTime">{{ info.startTime }} -</span>
        <span v-if="data.attributes?.endTime">&nbsp;{{ info.endTime }}</span>
      </div>
      <div class="loct-text">{{ info.location }}</div>
      <div class="seat-text" v-if="data?.seat?.id">
        <div>{{ $t('nftCard.seat') }}: {{ data.seat.name }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import MvProgressBar from "@/components/common/display/MvProgressBar.vue";
import {getLocationName} from '@/utils/stringUtil';
import {formatDate} from '@/models/utils/dateUtils';

export default defineComponent({
  name: "MmbsCardBack.vue",
  components: {
    MvProgressBar,
  },
  props: {
    data: {
      default: {
        name: '',
        nftUseStatus: {
          useableCnt: 0,
          totalCnt: 0,
        },
        attributes: {
          endDate: "",
          location: "",
          startDate: "",
          timeZone: "",
          startTime: "",
          endTime: "",
        },
      },
    },
  },
  setup(props) {
    const info = computed(() => {
      return {
        total: props.data.nftUseStatus?.totalCnt,
        current: props.data.nftUseStatus?.useableCnt,
        endDate: formatDate(props.data.attributes.endDate, {
          format: 'L',
          timeZone: props.data.attributes.timeZone,
        }),
        location: getLocationName(props.data.attributes.location),
        startDate: formatDate(props.data.attributes.startDate, {
          format: 'L',
          timeZone: props.data.attributes.timeZone,
        }),
        startTime: props.data.attributes.startTime,
        endTime: props.data.attributes.endTime,
      };
    });

    return {
      info,
    };
  },
});
</script>
